/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLinkSimpleH: {
  name: 'link-simple-h';
  data: string;
} = {
  name: 'link-simple-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 8a4 4 0 1 0 0 8h2a1 1 0 1 1 0 2H7A6 6 0 0 1 7 6h2a1 1 0 0 1 0 2H7Zm1 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm7-6a1 1 0 1 0 0 2h2a4 4 0 0 1 0 8h-2a1 1 0 1 0 0 2h2a6 6 0 0 0 0-12h-2Z" fill="currentColor"/></svg>`,
};
